// components/RespondingToNote.jsx — Anamoria SPA
// v1.0 — NEW-163 Increment B (2026-10-30): the quoted leader's note at the top of a contributor
//   capture / review screen when the member arrived via the Respond row (`?note=<id>`). Recognition
//   over recall (copy v1.0 B-8: "You're responding to {leader}'s note:" then the note, in full —
//   never silently cut). The note is re-derived from the space GET's groupNotes the page already
//   loads, so it survives refresh and the voice/video round trip (spec v0.2 §6, C-e). Renders
//   nothing when the id is missing or does not resolve (the capture then proceeds untagged).
//   Presentational; self-contained inline styles so the shared capture CSS modules stay untouched.
import { findGroupNote } from '../utils/contributorCapture';
import { firstName } from './GroupNoteBanner';

export default function RespondingToNote({ groupNotes, noteId, leaderName }) {
  const hit = findGroupNote(groupNotes, noteId);
  if (!hit) return null;
  const who = firstName(hit.note.authorName || leaderName);
  return (
    <section style={S.wrap} aria-label="The note you are responding to" data-testid="responding-to-note">
      <p style={S.kick}>You're responding to {who}'s note:</p>
      <blockquote style={S.quote}>{hit.note.body}</blockquote>
    </section>
  );
}

const S = {
  wrap: {
    margin: '12px 16px 4px',
    padding: '12px 16px',
    background: '#F6F0EA',
    border: '1px solid rgba(160, 128, 92, .45)',
    borderLeft: '4px solid var(--moment-accent, #744D2E)',
    borderRadius: 14,
  },
  kick: {
    margin: '0 0 6px',
    fontSize: 12.5,
    fontWeight: 600,
    color: 'var(--moment-accent, #744D2E)',
  },
  quote: {
    margin: 0,
    fontFamily: 'var(--font-serif)',
    fontSize: 15,
    lineHeight: 1.5,
    color: 'var(--color-text-primary, #2B2A2A)',
    whiteSpace: 'pre-line',
  },
};
